import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { auth } from "./api";

import Home from "./pages/Home";
import CommonNumber from "./pages/CommonNumber";
import DreamNumber from "./pages/DreamNumber";
import PreviousResult from "./pages/PreviousResult";
import Analytics from "./pages/Analytics";
import PredictTarget from "./pages/PredictTarget";
import TeerCalendar from "./pages/TeerCalendar";
import TeerCounter from "./pages/TeerCounter";
import TeerAacharya from "./pages/TeerAacharya";
import { About, Contact, Privacy, Terms } from "./pages/StaticPages";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { ManageResult, ManagePrevious } from "./pages/admin/ManageLists";
import BulkImport from "./pages/admin/BulkImport";
import ChangePassword from "./pages/admin/ChangePassword";

const RequireAuth = ({ children }) =>
  auth.isLoggedIn() ? children : <Navigate to="/admin" replace />;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/common-numbers" element={<CommonNumber />} />
          <Route path="/dream-numbers" element={<DreamNumber />} />
          <Route path="/previous-result" element={<PreviousResult />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/predict-target" element={<PredictTarget />} />
          <Route path="/calendar" element={<TeerCalendar />} />
          <Route path="/teer-counter" element={<TeerCounter />} />
          <Route path="/teer-aacharya" element={<TeerAacharya />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
          <Route path="/admin/result" element={<RequireAuth><ManageResult /></RequireAuth>} />
          <Route path="/admin/previous" element={<RequireAuth><ManagePrevious /></RequireAuth>} />
          <Route path="/admin/bulk-import" element={<RequireAuth><BulkImport /></RequireAuth>} />
          <Route path="/admin/password" element={<RequireAuth><ChangePassword /></RequireAuth>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
